import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageTemplate.css';

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
     
      <div className="page-content">
        <img src="/assets/about-logo.jpg" alt="Theometrics Global" className="page-logo" />
        <h1>About Theometrics Global</h1>
        
        <div className="page-text">
          <p>
            Theometrics Global is a global platform founded by Sotirios Hristos Stathopoulos (aka Sam Stathis) 
            with a mission to empower young creators and innovators. With strategic connections to the Hellenic 
            Olympic Committee and the International Olympic Academy, Theometrics provides a global stage for 
            talent through its educational programs, business initiatives, and international competitions.
          </p>
          
          {/* Два логотипа поруч */}
          <div className="dual-logos">
            <img src="/assets/TheaMou.png" alt="TheaMou" className="dual-logo" />
            <img src="/assets/MeaDea.png" alt="MeaDea by Theo" className="dual-logo" />
          </div>
          
          <h2>About TheaMou & MeaDea by Theo</h2>
          <p>
            TheaMou ("My Goddess") serves as the creative umbrella for MeaDea by Theo, Iellele by Theo, 
            and other related initiatives. Together they form a global cultural and lifestyle mission rooted 
            in Greek heritage and divine femininity—uniting fashion, art, education, entrepreneurship, and 
            enlightened enterprises under one purpose: to reignite the True Flame of Greece and uplift Mind, 
            Body, Spirit, Heart, and Purpose.
          </p>
          
          <p>
            MeaDea by Theo is a contemporary luxury fashion label where myth meets modernity, redefining 
            beauty with meaning, honoring heritage, and elevating design with conscience.
          </p>
          
          <div className="contact-section">
            <h3>FOLLOW US:</h3>
            <p>
              <a href="https://www.instagram.com/theometrics_universe/" target="_blank" rel="noopener noreferrer">
                @Theometrics_Universe
              </a>
              {' and '}
              <a href="https://www.instagram.com/theometrics_global/" target="_blank" rel="noopener noreferrer">
                @Theometrics_Global
              </a>
            </p>
            
            <h3>Contact</h3>
            <p>
              <a href="mailto:media@theouniverse.io">media@theouniverse.io</a>
            </p>
            <p>
              <a href="tel:+302126278220">+30 212 627 8220</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
